import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-benefits-of-lockable-ifp-protection-shutters',
  templateUrl: './benefits-of-lockable-ifp-protection-shutters.component.html',
  styleUrls: ['./benefits-of-lockable-ifp-protection-shutters.component.scss']
})
export class BenefitsOfLockableIfpProtectionShuttersComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Benefits of Lockable IFP Protection Shutters for Schools | VIRSA IFP Safety Solutions');
    this.metaService.updateTag({
      name: 'description',
      content: 'Discover the benefits of lockable IFP protection shutters for schools. Protect Interactive Flat Panels from damage, dust, and unauthorized access with VIRSA IFP Sliding Shutters.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'lockable IFP protection shutters, Interactive Flat Panel protection, IFP sliding shutters for schools, smart classroom safety solutions, Interactive Flat Panel accessories, VIRSA IFP protection shutters, IFP safety shutters, protect interactive panels in schools'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
